import { render, staticRenderFns } from "./tab-schedule.vue?vue&type=template&id=5d3cd325"
import script from "./tab-schedule.vue?vue&type=script&lang=js"
export * from "./tab-schedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports